// Underline-style tab bar used by every page that has sub-tabs.
// Pure styling — keeps the same look as the legacy inline-styled tabs so
// nothing visual changes when callers migrate.
export function Tabs({ tabs, activeId, onChange }) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 0,
        marginBottom: 20,
        borderBottom: '2px solid #dee2e6',
      }}
    >
      {tabs.map((t) => (
        <TabButton
          key={t.id}
          active={t.id === activeId}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </TabButton>
      ))}
    </div>
  );
}

export function TabButton({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '10px 24px',
        fontSize: 13,
        fontWeight: 600,
        cursor: 'pointer',
        border: 'none',
        background: active ? '#002159' : 'transparent',
        color: active ? '#fff' : '#666',
        borderRadius: '6px 6px 0 0',
        borderBottom: active ? '2px solid #FF6600' : '2px solid transparent',
        marginBottom: -2,
      }}
    >
      {children}
    </button>
  );
}
